import { useCallback, type KeyboardEvent } from 'react';
import type { TitleItem } from '../../doc/schema';
import { useBoard, usePane, usePaneStore } from '../context';
import { ALIGN_TO_JUSTIFY, textStyleCss, textStyleOf } from '../text/textStyle';

export function TitleBody({ item }: { item: TitleItem }) {
  const editing = usePane((s) => s.editingId === item.id);
  const pane = usePaneStore();
  const board = useBoard();

  const commit = useCallback(
    (text: string) => {
      if (text !== item.props.text) board.updateItem(item.id, { props: { text } });
      pane.getState().setEditing(null);
    },
    [board, item.id, item.props.text, pane],
  );

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (e.key === 'Escape' || e.key === 'Enter') e.currentTarget.blur();
  };

  const ts = textStyleOf(item);
  const style = { ...textStyleCss(ts), justifyContent: ALIGN_TO_JUSTIFY[ts.align] };

  if (editing) {
    return (
      <input
        className="title-editor"
        style={style}
        defaultValue={item.props.text}
        autoFocus
        spellCheck={false}
        onPointerDown={(e) => e.stopPropagation()}
        onKeyDown={onKeyDown}
        onBlur={(e) => commit(e.currentTarget.value)}
        onFocus={(e) => e.currentTarget.select()}
      />
    );
  }

  return (
    <div className="title-text" style={style}>
      {item.props.text || <span className="placeholder">Title</span>}
    </div>
  );
}
